import action from '../commons/prescriptionActionsStatus';

export const getRecommendedPrescriptionRequestAction = (consultationId, type) => {
    return {
        type: action.GET_RECOMMENDED_PRESCRIPTION_REQUEST,
        status: 'GET_RECOMMENDED_PRESCRIPTION_REQUEST',
        requestState: true,
        payload: {
            consultationId,
            type
        }
    };
};

export const getRecommendedPrescriptionSuccessAction = (result,prescriptionType) => {
    return {
        type: action.GET_RECOMMENDED_PRESCRIPTION_SUCCESS,
        status: 'Recommended Prescription retrieved sucessfully',
        result,
        prescriptionType,
        requestState: false,
    };
};

export const getRecommendedPrescriptionFailureAction = (error) => {
    return {
        type: action.GET_RECOMMENDED_PRESCRIPTION_FAILURE,
        status: 'Get Recommended Prescription failure',
        error,
        requestState: false,
    };
};

export const createPrescriptionRequestAction = (body) => {
    return {
        type: action.CREATE_PRESCRIPTION_REQUEST,
        status: 'CREATE_PRESCRIPTION_REQUEST',
        requestState: true,
        payload: {
           body
        }
    };
};

export const createPrescriptionSuccessAction = (result) => {
    return {
        type: action.CREATE_PRESCRIPTION_SUCCESS,
        status: 'Prescription created sucessfully',
        result,
        requestState: false,
    };
};

export const createPrescriptionFailureAction = (error) => {
    return {
        type: action.CREATE_PRESCRIPTION_FAILURE,
        status: 'Prescription creation failure',
        error,
        requestState: false,
    };
};


export const getPatientPrescriptionRequestAction = (consultationId) => {
    return {
        type: action.GET_PATIENT_PRESCRIPTION_REQUEST,
        status: 'GET_PATIENT_PRESCRIPTION_REQUEST',
        requestState: true,
        payload: {
         consultationId
        }
    };
};

export const getPatientPrescriptionSuccessAction = (result) => {
    return {
        type: action.GET_PATIENT_PRESCRIPTION_SUCCESS,
        status: 'Prescription RETRIVED sucessfully',
        result,
        requestState: false,
    };
};

export const getPatientPrescriptionFailureAction = (error) => {
    return {
        type: action.GET_PATIENT_PRESCRIPTION_FAILURE,
        status: 'Prescription get failure',
        error,
        requestState: false,
    };
};